export var Type;
(function (Type) {
    Type["NONE_TYPE"] = "NONE_TYPE";
    Type["APP"] = "APP";
    /** Future use */
    Type["TEMPLATE"] = "TEMPLATE";
    Type["PRIVATE_APP"] = "PRIVATE_APP";
    Type["WIX_OFFERING"] = "WIX_OFFERING";
    Type["VELO_APP"] = "VELO_APP";
    Type["API_KEY"] = "API_KEY";
    Type["FUNCTION_ACTIVATION_APP"] = "FUNCTION_ACTIVATION_APP";
})(Type || (Type = {}));
export var BusinessModel;
(function (BusinessModel) {
    BusinessModel["None"] = "None";
    BusinessModel["FREEMIUM"] = "FREEMIUM";
    BusinessModel["PREMIUM"] = "PREMIUM";
    BusinessModel["FREE"] = "FREE";
    BusinessModel["WIX_PREMIUM"] = "WIX_PREMIUM";
    BusinessModel["DYNAMIC"] = "DYNAMIC";
})(BusinessModel || (BusinessModel = {}));
export var PlanDescription;
(function (PlanDescription) {
    PlanDescription["UNKNOWN_DESCRIPTION"] = "UNKNOWN_DESCRIPTION";
    /** indicate that the description will be list of benefits */
    PlanDescription["BENEFITS"] = "BENEFITS";
    /** indicate that the description will custom_text field */
    PlanDescription["CUSTOM_TEXT"] = "CUSTOM_TEXT";
})(PlanDescription || (PlanDescription = {}));
export var IntervalUnit;
(function (IntervalUnit) {
    /** unknown interval unit */
    IntervalUnit["UNKNOWN"] = "UNKNOWN";
    /** day */
    IntervalUnit["DAY"] = "DAY";
    /** week */
    IntervalUnit["WEEK"] = "WEEK";
    /** month */
    IntervalUnit["MONTH"] = "MONTH";
    /** year */
    IntervalUnit["YEAR"] = "YEAR";
})(IntervalUnit || (IntervalUnit = {}));
export var TaxType;
(function (TaxType) {
    TaxType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    TaxType["REGULAR"] = "REGULAR";
    TaxType["EU_VAT"] = "EU_VAT";
    TaxType["JAPAN_JCT"] = "JAPAN_JCT";
    TaxType["AU_GST"] = "AU_GST";
    TaxType["BR_CNPJ"] = "BR_CNPJ";
    TaxType["RU_TIN"] = "RU_TIN";
    TaxType["IN_RNR"] = "IN_RNR";
    TaxType["IL_VAT"] = "IL_VAT";
    TaxType["US_TAX"] = "US_TAX";
    TaxType["SG_GST"] = "SG_GST";
    TaxType["CA_GST"] = "CA_GST";
    TaxType["CA_HST"] = "CA_HST";
    TaxType["CA_PST"] = "CA_PST";
    TaxType["CA_QST"] = "CA_QST";
    TaxType["NZ_GST"] = "NZ_GST";
    TaxType["MD_VAT"] = "MD_VAT";
    TaxType["CL_VAT"] = "CL_VAT";
    TaxType["MY_VAT"] = "MY_VAT";
    TaxType["KR_VAT"] = "KR_VAT";
    TaxType["TW_VAT"] = "TW_VAT";
    TaxType["AE_VAT"] = "AE_VAT";
    TaxType["NG_VAT"] = "NG_VAT";
    TaxType["IS_VAT"] = "IS_VAT";
    TaxType["GE_VAT"] = "GE_VAT";
    TaxType["TH_VAT"] = "TH_VAT";
    TaxType["TR_VAT"] = "TR_VAT";
    TaxType["NO_VAT"] = "NO_VAT";
    TaxType["UA_VAT"] = "UA_VAT";
    TaxType["IN_GST"] = "IN_GST";
    TaxType["KZ_VAT"] = "KZ_VAT";
    TaxType["TZ_VAT"] = "TZ_VAT";
    TaxType["IGIC_VAT"] = "IGIC_VAT";
    TaxType["KE_VAT"] = "KE_VAT";
    TaxType["PE_VAT"] = "PE_VAT";
    TaxType["SA_VAT"] = "SA_VAT";
})(TaxType || (TaxType = {}));
export var TaxSettingsTaxType;
(function (TaxSettingsTaxType) {
    TaxSettingsTaxType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    TaxSettingsTaxType["VAT"] = "VAT";
    TaxSettingsTaxType["GST"] = "GST";
})(TaxSettingsTaxType || (TaxSettingsTaxType = {}));
export var TagType;
(function (TagType) {
    TagType["NONE_TAG"] = "NONE_TAG";
    TagType["CATEGORY"] = "CATEGORY";
    TagType["COLLECTION"] = "COLLECTION";
})(TagType || (TagType = {}));
export var OpenConsentIn;
(function (OpenConsentIn) {
    OpenConsentIn["NONE_VALUE"] = "NONE_VALUE";
    OpenConsentIn["NEW_WINDOW"] = "NEW_WINDOW";
    OpenConsentIn["NEW_TAB"] = "NEW_TAB";
})(OpenConsentIn || (OpenConsentIn = {}));
export var MediaType;
(function (MediaType) {
    MediaType["VIDEO"] = "VIDEO";
    MediaType["IMAGE"] = "IMAGE";
    MediaType["YOUTUBE"] = "YOUTUBE";
})(MediaType || (MediaType = {}));
export var Order;
(function (Order) {
    Order["NONE_ORDER"] = "NONE_ORDER";
    Order["MOST_POPULAR"] = "MOST_POPULAR";
    /** either country param or get user business location and move down on the list web solution that does not supported in this location */
    Order["GEO"] = "GEO";
    Order["RANDOM"] = "RANDOM";
})(Order || (Order = {}));
export var Filter;
(function (Filter) {
    Filter["NONE_FILTER"] = "NONE_FILTER";
    /** base on country param include only apps on that countries */
    Filter["GEO_FILTER"] = "GEO_FILTER";
})(Filter || (Filter = {}));
export var PlatformType;
(function (PlatformType) {
    PlatformType["NONE_PLATFORM"] = "NONE_PLATFORM";
    PlatformType["EDITOR_PLATFORM"] = "EDITOR_PLATFORM";
    PlatformType["STAND_ALONE_PLATFORM"] = "STAND_ALONE_PLATFORM";
    PlatformType["BUSINESS_MANAGER_PLATFORM"] = "BUSINESS_MANAGER_PLATFORM";
    PlatformType["WIX_INTERNAL"] = "WIX_INTERNAL";
})(PlatformType || (PlatformType = {}));
export var VersionStatus;
(function (VersionStatus) {
    /** default, internal use status. do not use */
    VersionStatus["NONE_STATUS"] = "NONE_STATUS";
    /** a version which was created in the dev center and has not started the approval process yet */
    VersionStatus["DRAFT"] = "DRAFT";
    /** the version was submitted for review by the developer */
    VersionStatus["SUBMITTED"] = "SUBMITTED";
    /** the version is being reviewed by the app market team in cactus */
    VersionStatus["IN_REVIEW"] = "IN_REVIEW";
    /** our team approved the version */
    VersionStatus["APPROVED"] = "APPROVED";
    /** this version is published - only one version can be published at any given time; if this app was already published, the previously published version's status is now ARCHIVED */
    VersionStatus["PUBLISHED"] = "PUBLISHED";
    /** our team did not accept this version of the app */
    VersionStatus["DECLINED"] = "DECLINED";
    /** the status for versions that are no longer relevant */
    VersionStatus["ARCHIVED"] = "ARCHIVED";
    /** status for versions with no significant changes, e.g. for test app. for questions contact our team */
    VersionStatus["HIDDEN"] = "HIDDEN";
    /** mark apps as RELEASED, without adding to the apps cache, and allow users to install */
    VersionStatus["RELEASED"] = "RELEASED";
})(VersionStatus || (VersionStatus = {}));
//# sourceMappingURL=types.impl.js.map